import '../css/mobile.scss';
import '../css/splide.min.css';
import { EntryShared, socket, uiGameManager } from '../../shared/scripts/EntryShared.ts';
import { UIMMobileWebviewCommunication } from './ui_mobile_communication/UIMMobileWebviewCommunication.ts';
import { UIMSocketEventHandler } from './UIMSocketEventHandler.ts';
import { UIMManager } from './ui_html/UIMManager.ts';
import { UIMNotificationController } from './notifications/UIMNotificationController.ts';
import { UIMGameManager } from './ui_game/UIMGameManager.ts';
// eslint-disable-next-line boundaries/dependencies
import { UIWGameManager } from '../../web/scripts/ui_game/UIWGameManager.ts';
import { UIUtilsEjsVariables } from '../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIMDeviceHandler } from './ui_html/UIMDeviceHandler.ts';
import { UIMGameReviewController } from './ui_popup/UIMGameReviewController.ts';
import { EntryMobileUrlParameterController } from './EntryMobileUrlParameterController.ts';
import { ClientUserState } from '../../shared/scripts/ClientUserState.ts';
import { UIMGeneralServicesController } from './UIMGeneralServicesController.ts';
import { UIMSceneEnum } from '../../../shared/enums/UIMSceneEnums.ts';
import { registerMobileRoomClientHandlers } from './MobileRoomClientHandlers.ts';
import { UIAjaxWrapper } from '../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../shared/scripts/network/UIAPIEndpoints.ts';
import { registerSharedRoomClientHandlers } from '../../shared/scripts/SharedRoomClientHandlers.ts';
import { UIMDiscordActivityController } from './discord/UIMDiscordActivityController.ts';
import { UIMDoubleTapPurchaseController } from './ui_html/store/UIMDoubleTapPurchaseController.ts';
import { UIMDiscordSocketEventHandler } from './discord/UIMDiscordSocketEventHandler.ts';
export let uiManager;
class EntryMobile extends EntryShared {
    async initialize() {
        var _ClientUserState_userState;
        let discordActivityController;
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) discordActivityController = UIMDiscordActivityController.getInstance();
        await (discordActivityController === null || discordActivityController === void 0 ? void 0 : discordActivityController.waitForAuthentication());
        await ClientUserState.refresh();
        new UIMMobileWebviewCommunication();
        await this.initializeSoundAndVersionController();
        await EntryShared.initializeEntry();
        UIMDoubleTapPurchaseController.init();
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) void UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiReactivationMessage(), undefined, {
            platform: 'mobile'
        });
        this.webGLCheck();
        uiManager = new UIMManager();
        this.initializeUIManagerEvents(uiManager.uiManagerEvents);
        const gameManager = this.getGameManager();
        this.initializeGameManager(gameManager);
        EntryShared.initializeNotification(new UIMNotificationController());
        const generalServicesController = new UIMGeneralServicesController(uiManager);
        const socketActionController = this.createSocketActionController(uiGameManager, uiManager, generalServicesController);
        EntryShared.initializeSocket(socketActionController, ()=>uiManager.sceneController.scene == UIMSceneEnum.Game);
        registerSharedRoomClientHandlers(socket.roomClient);
        registerMobileRoomClientHandlers(socket.roomClient, uiManager);
        uiManager.init();
        generalServicesController.init();
        socket.connect();
        new UIMGameReviewController(gameManager);
        this.completeInitialization();
        discordActivityController === null || discordActivityController === void 0 ? void 0 : discordActivityController.hideLoadingScreen();
        EntryMobileUrlParameterController.loadParameterEvents();
        UIMDeviceHandler.sendUserIdForNotifications();
    }
    // eslint-disable-next-line class-methods-use-this
    getGameManager() {
        return UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? new UIMGameManager(uiManager.adController) : new UIWGameManager(uiManager.adController);
    }
    // eslint-disable-next-line class-methods-use-this
    createSocketActionController(gameManager, manager, generalServicesController) {
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) return new UIMDiscordSocketEventHandler(gameManager, manager, generalServicesController);
        return new UIMSocketEventHandler(gameManager, manager, generalServicesController);
    }
    constructor(){
        super();
        UIMDeviceHandler.initSavedInfoFromDevice();
        void this.initialize();
    }
}
new EntryMobile();
